module.exports = __webpack_public_path__ + "static/media/violin-course.fa629d2d.jpg";